import { render } from "./RetirementForm.vue?vue&type=template&id=6af901d8"
import script from "./RetirementForm.vue?vue&type=script&lang=js"
export * from "./RetirementForm.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/amatra-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__